import { FormikProps, useFormik } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DynamicForm from 'src/components/DynamicForm'
import { CartDetails } from 'src/redux/cart/types'
import { CartFormProps } from '../../types'
import { useUpdateCartDetails } from '../../useUpdateCartDetails'
import NextButton from '../NextButton'
import { useCheckout } from './useCheckout'
import { getInputFields, getValidationSchema } from './utils'

const BillingDetails: React.FC<CartFormProps> = ({ onNext, initialValues }) => {
  const { t } = useTranslation()
  const formik: FormikProps<CartDetails> = useFormik<CartDetails>({
    initialValues,
    validationSchema: getValidationSchema(),
    onSubmit: onNext,
    validateOnBlur: true,
    validateOnChange: true,
  })

  useUpdateCartDetails(formik)

  const { checkout, isLoading } = useCheckout()

  const inputFields = getInputFields(formik)

  return (
    <>
      <DynamicForm formikProps={formik} inputFields={inputFields} />
      <NextButton
        onClick={checkout}
        title={t('cartPages.proceedToCheckout')}
        isDisabled={!formik.isValid}
        isLoading={isLoading}
      />
    </>
  )
}

export default BillingDetails
